import styles from "./TimelineHeader.module.scss";

interface TimelineHeaderProps {
  hoursLabels: Date[];
};

const TimelineHeader: React.FC<TimelineHeaderProps> = ({
  hoursLabels,
}) => (
  <div className={styles.header}>
    <div className={styles.hours} style={{ gridTemplateColumns: `repeat(${hoursLabels.length - 1}, 1fr)` }}>
      {hoursLabels.slice(0, -1).map((d, i) => (
        <div key={i} className={styles.hour}>
          {String(d.getHours()).padStart(2, "0")}:{String(d.getMinutes()).padStart(2, "0")}
        </div>
      ))}
    </div>
  </div>
);

export default TimelineHeader;